export default __webpack_public_path__ + "aec72b9d92e38fe8a078cfb0b24a7473.png";